import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Box, Typography } from '@material-ui/core'
import { ServiceResponse } from '@mutual-libs/shared-types'
import { LoanRequestStatusBadge } from '../../../../components'
import { DocumentsGroup, DocumentAnalysisStatus } from '@mutual-services/account-documents-types'
import { formatDate } from '~/utils/date'

export type LoanRequestStatusProps = {
  documents: ServiceResponse<DocumentsGroup[]>,
  status: DocumentAnalysisStatus
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column'
  }
})

export const LoanRequestStatus: React.FC<LoanRequestStatusProps> = (props) => {
  const { documents, status } = props
  const classes = useStyles()

  const solicitationDate = useMemo(() => formatDate(documents[0].createdAt), [documents])

  return (
    <Box className={classes.container}>
      <Typography sx={{ fontWeight: 700, marginBottom: 2 }} variant='airbnbH4'>Seu pedido de empréstimo</Typography>
      <LoanRequestStatusBadge solicitationDate={solicitationDate} status={status} />
    </Box>
  )
}
